<template>
  <div class="privacy-policy-container">
    <div class="privacy-policy-content">
      <h1>{{ title }}</h1>
      <p class="last-update">
        <strong>{{ lastUpdate }}:</strong> {{ updateDate }}
      </p>

      <div class="section">
        <h2>{{ introduction }}</h2>
        <p v-html="introductionContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataCollected }}</h2>
        <p v-html="dataCollectedContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataPurpose }}</h2>
        <p v-html="dataPurposeContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataSharing }}</h2>
        <p v-html="dataSharingContent"></p>
      </div>

      <div class="section">
        <h2>{{ dataRetention }}</h2>
        <p v-html="dataRetentionContent"></p>
      </div>

      <div class="section">
        <h2>{{ security }}</h2>
        <p v-html="securityContent"></p>
      </div>

      <div class="section">
        <h2>{{ policyChanges }}</h2>
        <p v-html="policyChangesContent"></p>
      </div>

      <div class="section">
        <h2>{{ contact }}</h2>
        <p v-html="contactContent"></p>
      </div>

      <div class="section consent-section">
        <h2>{{ consent }}</h2>
        <p v-html="consentContent"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Privacy Policy of the Game Dioroom",
      lastUpdate: "Last update",
      updateDate: "01/09/2026",

      introduction: "Introduction",
      introductionContent: `
        Welcome to the game Dioroom, developed by Black Paladins. This Privacy Policy explains how we handle information when you use our game. Your privacy is important to us, and we are committed to protecting it.
      `,

      dataCollected: "Data Collected",
      dataCollectedContent: `
        Dioroom does not require account creation, login, or registration, and it does not actively collect any personally identifiable information from players.<br><br>
        The game does not collect data such as names, email addresses, phone numbers, physical addresses, or payment information.<br><br>
        However, the operating system or app store (such as Google Play) may automatically provide basic technical information, including:<br>
        - <strong>Device model and operating system version</strong><br>
        - <strong>Language and region settings</strong><br>
        - <strong>General performance data (such as crash reports)</strong><br><br>
        These data are not used to identify individual users and are only utilized to improve the stability and performance of the game.
      `,

      dataPurpose: "Purpose of Data",
      dataPurposeContent: `
        Any technical information provided by the platform is used solely for the following purposes:<br>
        - To improve game performance and stability<br>
        - To fix bugs and technical issues<br>
        - To ensure compatibility across different devices<br><br>
        Black Paladins does not use this data for marketing, profiling, or advertising purposes.
      `,

      dataSharing: "Data Sharing",
      dataSharingContent: `
        Black Paladins does not sell, rent, or share personal data with third parties.<br><br>
        Since Dioroom does not collect personal information, no user-identifiable data is shared with external partners.<br><br>
        Data may only be disclosed if required by law, legal process, or to protect the rights and safety of Black Paladins.
      `,

      dataRetention: "Data Retention and Deletion",
      dataRetentionContent: `
        Black Paladins does not store or retain any personal data from players.<br><br>
        Any technical or diagnostic data, when applicable, is handled by the platform provider (such as the app store or operating system) in accordance with their own data retention policies.
      `,

      security: "Security",
      securityContent: `
        We value the privacy and security of our players. Since Dioroom does not collect or store personal information, there is no database of personal data associated with the game.<br><br>
        We apply reasonable technical measures to ensure the game operates securely, but please note that no method of electronic transmission or storage is 100% secure.
      `,

      policyChanges: "Changes to This Privacy Policy",
      policyChangesContent: `
        This Privacy Policy may be updated from time to time. Any changes will be reflected by updating the "Last update" date at the beginning of this document.<br><br>
        We encourage you to review this policy periodically to stay informed about how your information is handled.
      `,

      contact: "Contact",
      contactContent: `
        If you have any questions about this Privacy Policy or the game Dioroom, please contact us:<br>
        Black Paladins - Support Team<br>
        Email: blackpaladinsgames@gmail.com
      `,

      consent: "Consent",
      consentContent: `
        By downloading, installing, or using the game Dioroom, you agree to this Privacy Policy.
      `
    };
  }
};
</script>


<style scoped>
.privacy-policy-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #1e1e2f;
  color: #e0e0e0;
  font-family: Arial, sans-serif;
  padding: 80px;
}

.privacy-policy-content {
  max-width: 800px;
  width: 100%;
  padding: 30px;
  border-radius: 12px;
  background: rgba(34, 34, 51, 0.85);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.5s ease-in-out;
}

.last-update {
  font-size: 1.1em;
  text-align: center;
  color: #cfcfcf;
  margin-bottom: 30px;
}

.section {
  margin-bottom: 25px;
}

p {
  font-size: 1.1em;
  line-height: 1.8;
  color: #e0e0e0;
  margin-bottom: 15px;
}

.consent-section p {
  font-style: italic;
  color: #ffd700;
}

strong {
  font-weight: bold;
}

.link {
  color: #ffcc00;
  text-decoration: underline;
}

.link:hover {
  text-decoration: none;
  color: #ffd700;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
